import { graphql } from "gatsby";
import React, { useEffect, useState } from "react";

import GroupProgramComponentPage from "../../../components/group-program";
import Layout from "../../../components/layout";
import Seo from "../../../components/seo";
import { ThemeContext } from "../../../context/ThemeContext";

const GroupSchoolsProgramTemplate = ({ data, location }) => {
  const [groupInstitute, setGroupInstitute] = useState("");

  const { program } = data || {};
  const programName = program && program?.title ? program?.title : "";
  const programId = program && program?.databaseId ? program?.databaseId : "";
  const programCode = program?.acfGroupPrograms?.programCode ?? programId;
  const groupsRecordTypeId = "0123k000001QapgAAC";

  const applyNow = `/group-application-form/?type=application&program=${programCode}&program_title=${programName}&group_institute=${groupInstitute}`;
  const enquireNow = `/enquiry-form/?type=group_enquiry&program=${programCode}&program_title=${programName}&record_type_id=${groupsRecordTypeId}`;
  const enquireLabel = "Educator <br/> Enquiry";
  const applyLabel = "Student <br/> Application";

  useEffect(() => {
    let url = new URL(location?.href);
    setGroupInstitute(url.searchParams.get("group_institute"));
  }, [location?.href]);

  return (
    <ThemeContext.Consumer>
      {(theme) => (
        <Layout
          pageTitle={programName}
          containerClass={"w-full mx-auto relative"}
          enquireNow={enquireNow}
          applyNow={applyNow}
          brandingOpts={{ ...theme }}
          enquireLabel={enquireLabel}
          applyLabel={applyLabel}
          isGroupPage={true}
        >
          <GroupProgramComponentPage
            data={data}
            location={location}
            theme={theme}
            applyNow={applyNow}
            enquireNow={enquireNow}
            groupInstitute={groupInstitute}
          />
        </Layout>
      )}
    </ThemeContext.Consumer>
  );
};

export const Head = ({ data }) => {
  const { program } = data ?? {};
  const { acfProgramsMeta: programDetails } = program ?? {};
  const programFeaturedImage =
    programDetails?.backgroundImage ??
    programDetails?.backgroundImage?.sourceUrl ??
    programDetails?.backgroundImage?.mediaItemUrl ??
    null;

  const { programItinerary } = programDetails || {};

  const location =
    program?.geographical?.nodes?.flatMap((item) => item.name) || [];

  const durationList =
    programItinerary?.flatMap((item) => {
      const duration =
        item?.itineraryDay
          ?.replaceAll(/\s|day/gi, "")
          ?.replaceAll(/\s|–|-/gi, "-")
          ?.split("-")
          ?.map((v) => parseInt(v)) ?? "";

      return duration?.length > 1
        ? Array.from(
            { length: duration[1] - duration[0] + 1 },
            (_, i) => i + duration[0]
          )
        : duration ?? "";
    }) || [];

  const formatDurationList = [
    {
      "@type": "CourseInstance",
      courseMode: "Onsite",
      location: location.join(", ") || "",
      courseSchedule: {
        "@type": "Schedule",
        duration: `P8H`,
        repeatCount: durationList?.length || 1,
        repeatFrequency: "Daily"
      }
    }
  ];

  const courseDetails = {
    description: program?.seo?.description ?? "",
    name: program?.seo?.title ?? program.title,
    hasCourseInstance: formatDurationList,
    offers: [
      {
        "@type": "Offer",
        category: "Paid"
      }
    ]
  };

  return (
    <Seo
      title={program?.seo?.title ?? program.title}
      description={program?.seo?.description}
      image={
        programFeaturedImage ??
        program?.globalConfig?.backgroundImage?.sourceUrl
      }
      translations={program?.translations}
      lang={program?.locale}
      courseDetails={courseDetails}
      meta={[
        {
          name: "robots",
          content: program?.seo?.robots
        }
      ]}
    />
  );
};

export const programQuery = graphql`
  query ($slug: String!) {
    program: wpGroupProgram(slug: { eq: $slug }) {
      ...groupProgramFullDataFragment
    }
    genericDetails: wp {
      globalProgramConfig: gviConfigSettings {
        acfGenericGlobalConfig {
          ...ExclusiveOffersFragment
          ...StickyWidgetFragment
        }
      }
    }
  }
`;
export default GroupSchoolsProgramTemplate;
